import { Button } from "@mantine/core";
import { useState } from "react";
import { generatePath, useNavigate } from "react-router";
import { ROUTES } from "../../../../../routes";
import type { WizardMissingData } from "../../../../../utils/backend-types";
import { MarkDoneActionButton } from "../../../components/MarkDoneActionButton";
import { MissingDataActionButton } from "../../../components/MissingDataActionButton";
import { AssignmentType } from "../../OnboardingWizard.constants";
import "./InvoiceAssignment.scss";

export type InvoiceAssignmentProps = {
  done: boolean;
  missingData: Array<WizardMissingData>;
  objectsAreMissing: boolean;
  isDisabled: boolean;
  projectId: string;
  updateSiteWizard: (type: AssignmentType) => Promise<void>;
};

function InvoiceAssignment({
  done,
  missingData,
  objectsAreMissing,
  projectId,
  updateSiteWizard,
  isDisabled
}: InvoiceAssignmentProps) {
  const navigate = useNavigate();

  const [isSpinning, setIsSpinning] = useState(false);
  const hasMissingData = missingData && missingData.length > 0;

  const CONTRACTS_URL = generatePath(ROUTES.mieterstrom.contracts, {
    projectId
  });

  function onClickSubmit() {
    setIsSpinning(true);
    updateSiteWizard(AssignmentType.Invoices).then(() => {
      setIsSpinning(false);
    });
  }

  function getComponentByStep() {
    if (objectsAreMissing && !done) {
      return (
        <div className="missing-data-container">
          <Button
            className="missing-data-button"
            color="primary"
            disabled={isDisabled}
            variant="default"
            onClick={() => navigate(CONTRACTS_URL)}
          >
            Verträge und Lieferungen anlegen
          </Button>
        </div>
      );
    } else if (hasMissingData && !done) {
      return (
        <MissingDataActionButton
          disabled={isDisabled}
          mt="xs"
          route={"vertraege"}
        />
      );
    } else if (!hasMissingData && !done) {
      return (
        <MarkDoneActionButton
          disabled={isDisabled}
          loading={isSpinning}
          onClick={() => onClickSubmit()}
        />
      );
    }
  }

  return <div className="InvoiceAssignment">{getComponentByStep()}</div>;
}

export { InvoiceAssignment };
